export default __webpack_public_path__ + "static/media/miro-logo.53db87e4.svg";